<template>
  <v-app-bar color="primary">
    <v-app-bar-nav-icon variant="text" @click.stop="drawer = !drawer" />

    <v-toolbar-title>Cemetery Community Marketplace</v-toolbar-title>
  </v-app-bar>

  <v-navigation-drawer v-model="drawer" :location="$vuetify.display.mobile ? 'bottom' : undefined" temporary>
    <v-list-item title="Cemetery Community" subtitle="Marketplace" />
    <v-divider></v-divider>
    <v-list-item link to="/">Listings</v-list-item>
    <v-list-item link to="/addnew">Add New Listing</v-list-item>
    <template v-slot:append>
      <v-divider></v-divider>
      <v-list-item link href="https://cemeterycommunity.com">Main Site</v-list-item>
    </template>
  </v-navigation-drawer>
</template>

<script>

export default {
  name: 'NavDrawer',

  data: () => ({
    drawer : false
  }),
}
</script>